import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import NavLinkList from './NavLinkList';
import enhance from './SideNav.enhancer';
import PropTypes from 'prop-types';

class SideNav extends React.Component {
  handleLogoClick() {
    this.props.history.push('/dashboard');
  }

  render() {
    const { classes, isCompany, currentPath, profile } = this.props;

    return (
      <Drawer
        className={
          profile.signUpComplete || profile.signUpComplete === undefined
            ? classes.drawer
            : classes.hiddenDrawer
        }
        variant="permanent"
        classes={{
          paper: classes.drawerPaper
        }}
        anchor="left"
      >
        <div className={classes.toolbar} onClick={() => this.handleLogoClick()}>
          <img src="/images/text-blue-big.png" className={classes.hpLogo} />
        </div>
        <Divider />
        <NavLinkList isCompany={isCompany} currentPath={currentPath} />
        {!isCompany && (
          <a
            href="https://discord.gg/KjBGXhX"
            target="_blank"
            className={classes.discordImageContainer}
          >
            <img
              className={classes.discordImage}
              src="/images/Discord-Logo+Wordmark-Color.png"
            />
          </a>
        )}
      </Drawer>
    );
  }
}

SideNav.PropTypes = {
  isCompany: PropTypes.string
};

export default enhance(SideNav);



// WEBPACK FOOTER //
// ./src/components/layout/SideNav.js